import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import navigation from './modules/navigation';
import shows from './modules/shows';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    navigation,
    shows,
  },
});
